import { render, staticRenderFns } from "./FooterTheme0.vue?vue&type=template&id=45148a68&scoped=true"
import script from "./FooterTheme0.vue?vue&type=script&lang=js"
export * from "./FooterTheme0.vue?vue&type=script&lang=js"
import style0 from "./FooterTheme0.vue?vue&type=style&index=0&id=45148a68&prod&lang=css"
import style1 from "./FooterTheme0.vue?vue&type=style&index=1&id=45148a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45148a68",
  null
  
)

export default component.exports